<div class="footer flex">
  <div class="flex-auto flex items-center container">
    <div class="font-medium">
      {{ "footer.versionInfo.description" | translate }}<br />
      <span class="hidden sm:inline-block">{{ "footer.versionInfo.copyright" | translate : param }}&nbsp;|&nbsp;</span>{{ "footer.versionInfo.version" | translate : param }}
    </div>
  </div>
</div>
